import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SignatureInputComponent} from './signature-input.component';
import {faFileSignature} from '@fortawesome/pro-light-svg-icons/faFileSignature';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TranslocoModule} from '@ngneat/transloco';
import {FormsModule} from '@angular/forms';
import {SignatureInputModalModule} from '@shared/signature-input-modal/signature-input-modal.module';
import {IneligibilityOverlayModule} from '@blocks/input/ineligibility-overlay/ineligibility-overlay.module';
import {SignaturePadModule} from '@shared/controls/signature-pad/signature-pad.module';
import {TextInputModule} from '../text-input/text-input.module';
import {DateInputModule} from '../date-input/date-input.module';
import {SubmissionGizmoModule} from '@shared/submission-gizmo/submission-gizmo.module';

@NgModule({
  declarations: [
    SignatureInputComponent
  ],
  imports: [
    CommonModule,
    SignaturePadModule,
    FontAwesomeModule,
    SignatureInputModalModule,
    FormsModule,
    TranslocoModule,
    IneligibilityOverlayModule,
    TextInputModule,
    DateInputModule,
    SubmissionGizmoModule
  ],
  exports: [
    SignatureInputComponent,
  ]
})
export class SignatureInputModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faFileSignature);
  }
}
